import React, { useMemo } from "react";
import { CustomizationInfoType } from "@/dto/order/CustomizationInfoDTO";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderStatus from "@/enum/OrderStatus";
import CustomizationInfoUnpaid from "./CustomizationInfoUnpaid";
import { observer } from "mobx-react-lite";
import OrderItemDTO from "@/dto/order/OrderItemDTO";
import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";
import OrderItemCustomizationInfo from "./OrderItemCustomizationInfo";

interface CustomizationInfoColumnProps {
    order: OrderDTO;
}

/**定制信息列 */
const CustomizationInfoColumn: React.FC<CustomizationInfoColumnProps> = function (props) {
    const { order } = props;

    const orderItems = useMemo(() => {
        const orderItems: OrderItemDTO[] = [];

        if (order.mergeSplitStatus === OrderMergeSplitStatus.MERGE_PARENT && order.childOrders?.length) {
            for (const childOrder of order.childOrders) {
                if (childOrder.orderItems?.length) {
                    orderItems.push(...childOrder.orderItems);
                }
            }
        } else {
            if (order.orderItems?.length) {
                orderItems.push(...order.orderItems);
            }
        }

        return orderItems;
    }, [order]);

    if (!orderItems) {
        return <td></td>;
    }

    if (!orderItems.length) {
        return <td></td>;
    }

    const hasCustomization = orderItems.find((orderItem) => {
        return orderItem.customizationInfo;
    });

    if (!hasCustomization) {
        return <td></td>;
    }

    if (order.status === OrderStatus.PENDING_PAYMENT) {
        return (
            <td>
                <p className="text-error text-small">买家付款后可查看定制图</p>
            </td>
        );
    }

    const unPaidOrderItem = orderItems?.find((orderItem) => {
        if (orderItem?.customizationInfo?.type !== CustomizationInfoType.H5 && orderItem?.customizationInfo?.content) {
            return false;
        } else {
            return orderItem?.customizationInfo?.customizationFeePaid === false;
        }
    });

    if (unPaidOrderItem) {
        return (
            <td style={{ fontSize: 11 }}>
                <CustomizationInfoUnpaid isSupplierShop={!!order.supplierDropShippingInfo} shopId={order.shopId} />
            </td>
        );
    }

    return (
        <td className="ec-customization-info-column">
            {orderItems.map((orderItem, index) => {
                return <OrderItemCustomizationInfo key={index} orderItem={orderItem} />;
            })}
        </td>
    );
};

export default observer(CustomizationInfoColumn);
